/**
 * MyCopro - Admin Layout
 * Layout principal pour l'espace Administration
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores';
import { AdminBottomNav } from './AdminBottomNav';
import { AdminMenu } from './AdminMenu';
import { useUIStore } from '@/stores';

// ============================================================================
// BANDEAU IMPERSONATION
// ============================================================================

const ImpersonationBanner: React.FC = () => {
  const { impersonation, stopImpersonation } = useAuthStore();

  if (!impersonation.isActive || !impersonation.targetUser) {
    return null;
  }

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <span className="text-amber-100">👁️ Mode visualisation :</span>
        <span className="font-semibold">{impersonation.targetUser.name}</span>
        <span className="text-amber-200">({impersonation.targetUser.category})</span>
      </div>
      <button
        onClick={stopImpersonation}
        className="bg-white text-amber-600 px-3 py-1 rounded-full text-sm font-medium hover:bg-amber-50 transition-colors"
      >
        Quitter
      </button>
    </div>
  );
};

// ============================================================================
// LAYOUT PRINCIPAL
// ============================================================================

export const AdminLayout: React.FC = () => {
  const { isMenuOpen, closeMenu } = useUIStore();
  const { impersonation } = useAuthStore();

  // Si en mode impersonation, ne pas afficher le layout admin
  // L'utilisateur voit l'interface de l'utilisateur impersonné
  if (impersonation.isActive) {
    return (
      <div className="min-h-screen bg-gray-50">
        <ImpersonationBanner />
        <Outlet />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 pb-20">
      {/* Menu latéral Admin */}
      <AdminMenu isOpen={isMenuOpen} onClose={closeMenu} />

      {/* Contenu principal */}
      <main>
        <Outlet />
      </main>

      {/* Navigation basse */}
      <AdminBottomNav />
    </div>
  );
};

export default AdminLayout;
